import React from 'react';
import PriceWidgetRenderer from './PriceWidgetRenderer';

const Preview: React.FC = () => (
  <PriceWidgetRenderer config={{}} />
);

export default Preview;
